module.exports = __webpack_public_path__ + "img/Edit Patient - Blue.22639bc0.png";